import { render, staticRenderFns } from "./home.vue?vue&type=template&id=49e8466c&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=49e8466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8466c",
  null
  
)

export default component.exports